import React from 'react';
import clsx from 'clsx';
import { reFetchConfig } from '@/hooks/paging';
import PanelContainer from '@/components/wrappers/PanelContainer';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';
import { defaultEvent } from '../helper';

const SubscribersPanelContainer = ({
  category,
  children,
  className,
  code,
  compact,
  onChange,
  url,
}) => {
  const event = defaultEvent(category);
  const state = Selectors.useSubscribersPanelContainer({ category, code, event });
  const config = compact ? reFetchConfig(state.subscribers, state) : undefined;
  Fetch.useFetchSubscribers({ category, code, event }, state.readStatus, config);

  return (
    <PanelContainer
      canAccess={state.canRead}
      exists={state.exists}
      name={state.name}
      onChange={onChange}
      readErrors={state.readErrors}
      url={url}
    >
      <div className={clsx('aridhia-subscribers-panel-container', className)}>
        { children }
      </div>
    </PanelContainer>
  );
};

export default SubscribersPanelContainer;
